import {
  FINANCE_ALL_PURCHASING_INVOICES_ERROR,
  FINANCE_ALL_PURCHASING_INVOICES_FETCHING_DATA,
  FINANCE_ALL_PURCHASING_INVOICES_GET_NEW_DATA,
  FINANCE_ALL_PURCHASING_INVOICES_INDEX
} from "../../typesAction";

const INITIAL_STATE = {
  purchasingInvoices: [],
  totalItems: 0,
  errorMessage: null,
  inProgress: false,
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case FINANCE_ALL_PURCHASING_INVOICES_INDEX:
      return {
        ...state,
        filters: action.payload.filters,
        totalItems: action.payload.data["hydra:totalItems"],
        purchasingInvoices: action.payload.data["hydra:member"],
        vewControll: action.payload.data["hydra:view"],
        errorMessage: null,
        inProgress: false
      };
    case FINANCE_ALL_PURCHASING_INVOICES_GET_NEW_DATA:
      return {
        ...state,
        purchasingInvoices: action.payload["hydra:member"],
        totalItems: action.payload["hydra:totalItems"],
        //viewControll: action.payload["hydra:view"],
        errorMessage: null,
        inProgress: false
      };
    case FINANCE_ALL_PURCHASING_INVOICES_FETCHING_DATA:
      return { ...state, inProgress: action.payload, errorMessage: null };
    case FINANCE_ALL_PURCHASING_INVOICES_ERROR:
      return { ...state, errorMessage: action.data, inProgress: false };
    default:
      return state;
  }
}
